import React, { lazy, useEffect, useState } from "react";

import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow, CWidgetStatsA
} from "@coreui/react";
import CIcon from '@coreui/icons-react'
import {
  cilChart, cilChevronLeft, cilChevronRight, cilPencil, cilTrash
} from "@coreui/icons";

import { AppFooter, AppHeader, AppSidebar } from "../../components";
import { Link, useHistory } from "react-router-dom";
import { dashboardService } from "../../services/dashboard.service";
import ReactPaginate from "react-paginate";

const AllTeams = () => {

  const [users, setUsers] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  let history = useHistory();

  useEffect(() => {
    allPlayers()
  }, []);

  let allPlayers = (e) => {
    let page = e?.selected ?? 0;
    dashboardService.allTeams(page + 1).then(({data}) => {
      console.log(data);
      if (data.status_code == 200){
        setUsers(data.users.data)
        setTotalPage(data.users.last_page)
        console.log(data.users.data);
      }
    })

  }

  let deleteUser = (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Do you really want to delete?') ===  true){
      dashboardService.deleteTeam(id).then(({ data }) => {
        console.log(data);
        if (data.status_code == 200){
          allPlayers()
        }
      })
    }
  }

  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <div className="rt-themetableholder">
            <CTable striped>
              <CTableHead>
                <CTableRow>
                  {/* <CTableHeaderCell scope="col">#</CTableHeaderCell> */}
                  <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Email</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {users.map(user => {
                  return (<CTableRow key={user.id}>
                    {/* <CTableHeaderCell scope="row">{user.id}</CTableHeaderCell> */}
                    <CTableDataCell>{user.full_name}</CTableDataCell>
                    <CTableDataCell>{user.email}</CTableDataCell>
                    <CTableDataCell>
                      <Link to={'/team/edit/'+user.id}>
                        <CIcon icon={cilPencil} />
                      </Link>
                      <Link to={'/team/'+user.id+'/leaderboard'}>
                        <CIcon icon={cilChart} />
                      </Link>

                      <button onClick={e => deleteUser(user.id)} className="delete-icon">
                        <CIcon icon={cilTrash} />
                      </button>
                    </CTableDataCell>
                  </CTableRow>)
                })}
              </CTableBody>
            </CTable>
          </div>
          {totalPage > 1 ?
            <ReactPaginate
              previousLabel={<CIcon icon={cilChevronLeft} />}
              nextLabel={<CIcon icon={cilChevronRight} />}
              breakLabel={'...'}
              breakClassName={'page-item'}
              nextClassName={'rt-next page-item'}
              previousClassName={'rt-prev page-item'}
              pageCount={totalPage}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              previousLinkClassName={'page-link'}
              disabledClassName={'disabled'}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={(e) => allPlayers(e)}
              containerClassName={'rt-pagination pagination'}
              activeClassName={'active'}
            /> : ''}
        </div>
        {/* <AppFooter /> */}
      </div>
    </div>
  )
}

export default AllTeams
